import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { Subject } from 'rxjs';

@Component({

  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [CommonModule]
})
export class LoaderComponent {
  private readonly loaderService = inject(LoaderService);

  isLoading: Subject<boolean> = this.loaderService.isLoading;
}
